import { render } from "./BadgeConvocatoriaStatus.vue?vue&type=template&id=6d7b27de"
import script from "./BadgeConvocatoriaStatus.vue?vue&type=script&lang=js"
export * from "./BadgeConvocatoriaStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__